<template>
    <div ckass="container">
        <div class="text-muted mb-2">Select submitted claim document(s) to link response.</div>                                                       
        <div class="input-group input-group-sm mb-1 mr-2">
            <div class="input-group-prepend">
                <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
            </div>
            <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
        </div>
        <div>
            <table class="table table-sm font-smaller mb-3">
                <thead>
                    <tr>
                        <th>Document</th>
                        <th class="fit">Submitted</th>
                        <th class="fit">Response</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="filteredDocuments.length">
                        <tr v-for="doc in filteredDocuments" :key="'inbox-submitted-document-' + doc.id">
                            <td class="checkbox-position">
                                <div class="custom-control custom-checkbox align-center">
                                    <input :id="'inbox-document-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected" @change="onChange($event, doc)">
                                    <label class="custom-control-label pt-1" :for="'inbox-document-checkbox-' + doc.id" :title="doc.document_type.name + ' - ' + doc.description">
                                        {{ doc.document_type.name }} - {{ doc.description | truncate(15) }}
                                    </label>
                                </div>                                        
                            </td>
                            <td class="fit pt-3">{{ doc.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss')  }}</td>
                            <td class="fit text-center">
                                <div v-if="doc.document_type_id == DocumentType.LWC_FORM_1010">
                                    <div class="btn-group dropdown">
                                        <button type="button" class="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown" :disabled="!doc.selected">
                                            <i v-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_APPROVED" class="fas fa-lg fa-thumbs-up text-success"></i>
                                            <i v-else-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_APPROVED_WITH_MODIFICATIONS" class="fas fa-lg fa-thumbs-up text-secondary"></i>
                                            <i v-else-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_DENIED" class="fas fa-lg fa-thumbs-down text-danger"></i>                                 
                                            <i v-else class="far fa-lg fa-question-circle text-muted"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right font-smaller">
                                            <a class="dropdown-item" @click="updateStatus(doc, null)"><i class="far fa-lg fa-question-circle text-muted"></i> No Response</a>
                                            <div class="dropdown-divider"></div>                                                    
                                            <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_APPROVED)"><i class="fas fa-lg fa-thumbs-up text-success"></i> Approved</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_APPROVED_WITH_MODIFICATIONS)"><i class="fas fa-lg fa-thumbs-up text-secondary"></i> Approved with Modifications</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_DENIED)"><i class="fas fa-lg fa-thumbs-down text-danger"></i> Denied</a>
                                        </div>                                                 
                                    </div>
                                </div>
                                <div v-else-if="doc.document_type_id == DocumentType.LWC_FORM_1009">
                                    <div class="btn-group dropdown">
                                        <button type="button" class="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown" :disabled="!doc.selected">
                                            <i v-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED" class="fas fa-lg fa-thumbs-up text-success"></i>
                                            <i v-else-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_DISPUTE_DENIED" class="fas fa-lg fa-thumbs-down text-danger"></i>                                 
                                            <i v-else class="far fa-lg fa-question-circle text-muted"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right font-smaller">
                                            <a class="dropdown-item" @click="updateStatus(doc, null)"><i class="far fa-lg fa-question-circle text-muted"></i> No Response</a>
                                            <div class="dropdown-divider"></div>                                                    
                                            <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED)"><i class="fas fa-lg fa-thumbs-up text-success"></i> Approved</a>
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_DISPUTE_DENIED)"><i class="fas fa-lg fa-thumbs-down text-danger"></i> Denied</a>
                                        </div>                                                 
                                    </div>
                                </div>                                                                 
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr><td class="text-center text-muted" colspan="3"><h5>No Documents</h5></td></tr>
                    </template>
                </tbody>
            </table>
        </div>       
    </div>    
</template>

<script>
import { DocumentType, DocumentStatus } from '../../constants.js';

export default {
    props: {
        claimId: Number,
        documentTypeId: Number
    },
    data() {
        return {

            // import constants into the template
            DocumentType: DocumentType,
            DocumentStatus: DocumentStatus,

            documents: [],
            searchString: ''
        }
    },
    computed: {
        filteredDocuments: function () {
            const self = this;
            return self.documents.filter(e => e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
        },
        selectedDocuments: function () {
            const self = this;
            return self.documents.filter(e => e.selected);
        },
        
    },   
    methods: {
        updateStatus: function (document, status) {
            document.document_status_id = status;
            this.$forceUpdate();
        },
        onChange(e, document) {
            if (!e.target.checked) {
                document.document_status_id = null;
            }
        }      
    },
    created() {

        // we must have a claim id but don't necessarily need a document type id
        if (this.claimId) {

            axios.get('/ajax/inbox/claims/' + this.claimId + '/document-types/' + this.documentTypeId + '/documents')
            .then(response => {
                this.documents = response.data.map(e => { 
                    this.$set(e, 'selected', false);
                    this.$set(e, 'status', null); 
                    return e; 
                });
            })
            .catch(error => {
                // TODO: handle errors with toastr
            }); 
        }       
    },
    watch: {
        documents: { 
            handler(value) {
                this.$emit('selected', this.selectedDocuments);
            },
            deep: true
        }
    }       
}
</script>

<style scoped>
    .checkbox-position {
        padding-top: 12px;
    }
    
    .font-smaller {
        font-size: .75rem;
    }
</style>